import styled from 'styled-components'

const Title = styled.h1`
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 40px;
`

export default Title
